import config from '../../../appConfig/AppConfig';

const vanityDomain = config().vanityDomain;

const ENTRY_KEY = '_entry';
const ENTRY_PANEL_KEY = '_entryPanel';
const ENTRY_TEXT_AREA_KEY = '_entryTextArea';
const IFRAME_VIDEO_KEY = '_iframeVideoKey';
const VIDEO_INPUT = '_videoInput';
const PERSON_SIGNUP_KEY = '_personSignupKey';
const SUGGESTED_ENTRY_KEY = '_suggestedEntryKey';
const FAQ_BASE_URL = `${vanityDomain}/guestbooks/faq.aspx`;
const GUIDELINES_BASE_URL = `${vanityDomain}/guestbooks/posting-guidelines.aspx`;

const OBIT_TYPE_LEGACY = 'legacy';
const OBIT_TYPE_MEMORIAM = 'memoriam';
const OBIT_TYPE_TRIBUTES_UNPAID = 'tributes_unpaid';
const OBIT_TYPE_INTERNATIONAL_UNPAID = 'international_unpaid';
const OBIT_TYPE_INTERNATIONAL_PAID = 'international_paid';

const FLOWER_TYPE_LEGACY = 'legacy';

// this is a value used for mimetype identification AND display
const MEDIA_TYPES = {
  video: 'Video',
  image: 'Photo',
  audio: 'Audio',
  default: 'Item',
};

const AD_PAGENAME = 'person';

const AD_PGB = {
  adSize: [[300, 200]],
  clientLoadOnly: true,
  maxIdleAdRefreshes: 0,
  pageName: AD_PAGENAME,
  positionId: 'custom-1',
  slotName: 'custom-1',
};

const AD_DIGNITY_MEMORIAL = {
  adSize: [[1, 1]],
  clientLoadOnly: true,
  maxIdleAdRefreshes: 0,
  pageName: AD_PAGENAME,
  positionId: 'tracking-1',
  slotName: 'tracking-1',
};

const PROMO_ADVICE_AND_SUPPORT = 'adviceAndSupport';

const PERSON_PAGE_TYPE = {
  personPage: 'person_page',
  batesvillePersonPage: 'batesville_person_page',
  forestLawnPersonPage: 'fl_person_page',
  tributesFhPersonPage: 'tributes_fh_person_page',
};

const FUNERAL_HOME_TYPE = {
  batesville: 'batesville',
  forestlawn: 'forestlawn',
  tributes: 'tributes',
};

const BATESVILLE_LOCATION_TYPE_NONE = 'NONE';

const QUESTION_PARAM = 'question';

const AFFILIATE_PARAM = 'affiliateId';
const AFFILIATE_COOKIE = {
  name: 'LegacyGlobal',
  idKey: 'AffiliateId',
  urlKey: 'AffiliateUrl',
  siteNameKey: 'AffiliateSiteName',
};

// person-service changes only those two from real sitename to gaSitename, all the rest are the sitename
const GA_SITENAMES = {
  dignityMemorial: 'sci',
  tributes: 'independent'
};

export {
  AD_DIGNITY_MEMORIAL,
  AD_PGB,
  AFFILIATE_COOKIE,
  AFFILIATE_PARAM,
  BATESVILLE_LOCATION_TYPE_NONE,
  ENTRY_KEY,
  ENTRY_PANEL_KEY,
  ENTRY_TEXT_AREA_KEY,
  FAQ_BASE_URL,
  FLOWER_TYPE_LEGACY,
  FUNERAL_HOME_TYPE,
  GUIDELINES_BASE_URL,
  IFRAME_VIDEO_KEY,
  OBIT_TYPE_LEGACY,
  OBIT_TYPE_MEMORIAM,
  OBIT_TYPE_TRIBUTES_UNPAID,
  OBIT_TYPE_INTERNATIONAL_UNPAID,
  OBIT_TYPE_INTERNATIONAL_PAID,
  PERSON_PAGE_TYPE,
  PROMO_ADVICE_AND_SUPPORT,
  QUESTION_PARAM,
  VIDEO_INPUT,
  MEDIA_TYPES,
  PERSON_SIGNUP_KEY,
  SUGGESTED_ENTRY_KEY,
  GA_SITENAMES,
};



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/constants.js